import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M108 41.87C108 41.87 80.37 27.42 78.97 25.66C77.57 23.9 76.63 1 76.63 1H54.62C54.62 1 53.68 23.9 52.28 25.66C50.88 27.42 23.25 41.87 23.25 41.87C23.25 41.87 35.5 56.92 65.63 56.92C95.76 56.92 108 41.87 108 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.72 47.5699C118.64 43.9399 84.08 26.7599 84.08 26.7599L78.95 17.1799L65.62 38.7299L52.29 17.1799L47.16 26.7599C47.16 26.7599 12.6 43.9299 9.52 47.5699C6.44 51.1999 2 73.5499 2 73.5499H129.23C129.24 73.5499 124.8 51.1999 121.72 47.5699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M58.5599 28.11L48.0999 47.33L47.1699 26.76" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <path d="M72.71 28.11L83.18 47.33L84.0999 26.76" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <path
        d="M65.6203 49.6598C66.6144 49.6598 67.4203 48.8539 67.4203 47.8598C67.4203 46.8657 66.6144 46.0598 65.6203 46.0598C64.6262 46.0598 63.8203 46.8657 63.8203 47.8598C63.8203 48.8539 64.6262 49.6598 65.6203 49.6598Z"
        fill={outline}
      />
      <path
        d="M65.6203 67.3598C66.6144 67.3598 67.4203 66.5539 67.4203 65.5598C67.4203 64.5657 66.6144 63.7598 65.6203 63.7598C64.6262 63.7598 63.8203 64.5657 63.8203 65.5598C63.8203 66.5539 64.6262 67.3598 65.6203 67.3598Z"
        fill={outline}
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6249"
          y1="35.0428"
          x2="65.6249"
          y2="24.2066"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
